import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Import tester UDIDs already collected by Firebase App Distribution (UCH-442).
 * Fetches every distinct Firebase project of the enabled mobile product's iOS
 * channels, matches each tester email (FAD device name is
 * `"<email> - <device model>"`) against primary + additional user emails, and
 * inserts unknown UDIDs for the matched owner. Unmatched testers are reported,
 * never inserted. Idempotent. Requires `releases:udids:manage`.
 */
export const importFadAppleUdids = defineEndpoint({
  method: 'POST',
  path: '/v1/apple-udids/import-fad',
  params: z.object({}),
  query: z.object({}),
  body: z.object({}).strict(),
  response: z.object({
    data: z.object({
      imported: z.number(),
      skipped: z.number(),
      unmatched: z.array(z.object({ email: z.string(), model: z.string() })),
    }),
  }),
});
